module.exports = __webpack_public_path__ + "static/media/video_fachada-polanco.33bfa5d8.jpg";